module.exports = __webpack_public_path__ + "img/img12.d4e26e44.svg";